import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	ReturnedRollRow,
	ReturnedRollsDateBasis,
} from "../models/ReturnedRolls";

export interface GetReturnedRollsParams {
	start: string;
	end: string;
	dateBasis: ReturnedRollsDateBasis;
	scrapped: boolean;
	broken: boolean;
	returned: boolean;
	awaitingReturn: boolean;
	signal?: AbortSignal;
}

// Retirement (scrapped / broken) and return (returned / awaiting) are independent filters,
// applied by the procedure. BIT params go as JS booleans (the API rejects numbers).
export const getReturnedRollsData = async ({
	start,
	end,
	dateBasis,
	scrapped,
	broken,
	returned,
	awaitingReturn,
	signal,
}: GetReturnedRollsParams): Promise<ReturnedRollRow[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "start", value: start },
		{ name: "end", value: end },
		{ name: "scrapped", value: scrapped },
		{ name: "broken", value: broken },
		{ name: "returned", value: returned },
		{ name: "awaitingReturn", value: awaitingReturn },
		{ name: "dateBasis", value: dateBasis },
	];
	const resp = await apiService.callV2(
		"[ROLLS].[GetReturnedRollsDataWeb]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching returned rolls");
	}
	return get(resp, "data.tables[0].rows", []) as ReturnedRollRow[];
};
